/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TechnicalAccountUpsert } from '../../models/technical-account-upsert';

export interface UpdateTechnicalAccount$Params {

/**
 * The object ID. Must be a valid ID.
 */
  uid: string;
  
    /**
     * The technical account upsert object
     */
    body: TechnicalAccountUpsert
}

export function updateTechnicalAccount(http: HttpClient, rootUrl: string, params: UpdateTechnicalAccount$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, updateTechnicalAccount.PATH, 'put');
  if (params) {
    rb.path('uid', params.uid, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

updateTechnicalAccount.PATH = '/technical-accounts/{uid}';
